import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import clsx from 'clsx';

export function ThemeToggle() {
  const { mode, setMode } = useTheme();
  const opts: { value: 'light' | 'dark' | 'system'; icon: React.ReactNode; label: string }[] = [
    { value: 'light', icon: <Sun className="h-3.5 w-3.5" />, label: 'Light' },
    { value: 'dark', icon: <Moon className="h-3.5 w-3.5" />, label: 'Dark' },
    { value: 'system', icon: <Monitor className="h-3.5 w-3.5" />, label: 'System' },
  ];
  return (
    <div className="flex rounded-md border border-gray-200 bg-white p-0.5 text-xs dark:border-gray-700 dark:bg-gray-900">
      {opts.map((o) => (
        <button
          key={o.value}
          onClick={() => setMode(o.value)}
          title={o.label}
          className={clsx(
            'rounded px-2 py-1 transition',
            mode === o.value
              ? 'bg-primary-600 text-white'
              : 'text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800',
          )}
        >
          {o.icon}
        </button>
      ))}
    </div>
  );
}
